import { render, staticRenderFns } from "./LifeDatesModal.vue?vue&type=template&id=4a8e64d5&"
import script from "./LifeDatesModal.vue?vue&type=script&lang=js&"
export * from "./LifeDatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports